// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 12) return "static/js/f9cf4a0f9fd0ed675ec1.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"3f1b8cea7bb193f51077","155":"a0b07ad481f31925a523","156":"bb7dc096894418d96298"}[chunkId] + ".chunk.js";
};